import { ComponentPropsWithoutRef, CSSProperties, forwardRef } from 'react';

export interface GWPSkeletonBlockProps extends ComponentPropsWithoutRef<'span'> {
	width?: CSSProperties['width'];
	height?: CSSProperties['height'];
}

const GWPSkeletonBlock = forwardRef<HTMLSpanElement, GWPSkeletonBlockProps>(function GWPSkeletonBlock(
	{ className, width, height, style, ...props },
	ref,
) {
	const rootClassName = className ? `gwp-skeleton-block ${className}` : 'gwp-skeleton-block';
	const blockStyle = {
		...style,
		'--gwp-skeleton-block-width': typeof width === 'number' ? `${width}px` : width,
		'--gwp-skeleton-block-height': typeof height === 'number' ? `${height}px` : height,
	} as CSSProperties;

	return <span ref={ref} className={rootClassName} style={blockStyle} aria-hidden="true" {...props} />;
});

GWPSkeletonBlock.displayName = 'GWPSkeletonBlock';

export default GWPSkeletonBlock;
